export default [
  {
    path: '/poy-report',
    name: 'poy-report',
    component: () => import('@/views/report/PoyReport.vue'),
    meta: {
      resource: 'report',
      action: ['read', 'update'],
      pageTitle: 'poyReport.title',
      breadcrumb: [{ text: 'poyReport.title', active: true }],
    },
  },
  {
    path: '/win-lose',
    name: 'win-lose',
    component: () => import('@/views/report/WinLose.vue'),
    meta: {
      resource: 'report',
      action: ['read', 'update'],
      pageTitle: 'Win / Lose',
      breadcrumb: [
        {
          text: 'Win / Lose',
          active: true,
        },
      ],
    },
  },
  {
    path: '/transaction',
    name: 'transaction',
    component: () => import('@/views/report/Transaction.vue'),
    meta: {
      resource: 'report',
      action: ['read', 'update'],
      pageTitle: 'Transaction',
      breadcrumb: [
        {
          text: 'Transaction',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lotto-report',
    name: 'lotto-report',
    component: () => import('@/views/report/LottoReport.vue'),
    meta: {
      resource: 'report',
      action: ['read', 'update'],
      pageTitle: 'Lotto Report',
      breadcrumb: [
        {
          text: 'Lotto Report',
          active: true,
        },
      ],
    },
  },
]
